/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import common from '../common/index';

export default {
  setDocumentTitle(state, payload) {
    state.documentTitle = payload.text;
    document.title = payload.text;
    document.getElementById('og:title').content = state.documentTitle;
  },
  setDefaultImage(state, payload) {
    state.defaultImgUrl = payload.text;
    document.getElementById('og:image').content = payload.text;
  },
  setDescription(state, payload) {
    state.description = payload.text;
    document.getElementById('og:description').content = state.description;
  },
  setKeywords(state, payload) {
    state.keywords = payload.text;
    document.getElementById('keywords').content = state.keywords;
  },
  setFaviconURL(state, payload) {
    state.faviconURL = payload.faviconURL;
    document.getElementById('faviconid').href = state.faviconURL;
  },
  updateLocaleFromLocalStorage: (state) => {
    console.log(`localStorage.getItem('locale'): ${localStorage.getItem('locale')}`);
    state.currentLocale = localStorage.getItem('locale') !== null ? localStorage.getItem('locale') : 'EN';
  },
  setAvailableLocales(state, payload) {
    state.availableLocales = payload.availableLocales;
  },
  setSettingsPageLocales(state, payload) {
    state.settingsPageLocales = payload.settingsPageLocales;
  },
  setLocale(state, payload) {
    state.currentLocale = payload.currentLocale;
    for (let i = 0; i < state.settingsPageLocales.length; i += 1) {
      state.settingsPageLocales[i] = { isActive: false };
    }
    let i = -1;
    // eslint-disable-next-line
    for (const key in state.availableLocales) {
      // eslint-disable-next-line
      if (state.availableLocales.hasOwnProperty(key)) {
        i += 1;
        if (key === state.currentLocale) {
          state.settingsPageLocales[i].isActive = true;
        }
      }
    }
  },
  storeTranslations(state, payload) {
    state.translations = payload.translations;
  },
  changeCSSFile(state) {
    if (state.currentLocale === 'AR' || state.currentLocale === 'FA') {
      document.getElementById('cssid').href = '/static/css/main_AR.min.css';
      document.getElementById('skinid').href = `/static/skins/skin_${common.state.duelSkin}/css/skin_AR.css`;
    } else {
      document.getElementById('cssid').href = '/static/css/main.min.css';
      document.getElementById('skinid').href = `/static/skins/skin_${common.state.duelSkin}/css/skin.css`;
    }
  },
  updateActiveLocale(state, index) {
    console.log('index:', index);
    if (state.settingsPageLocales.length > 0) {
      for (let i = 0; i < state.settingsPageLocales.length; i += 1) {
        state.settingsPageLocales[i].isActive = false;
      }
      state.activeLocale = index;
      state.settingsPageLocales[index].isActive = true;
    }
  },
  storeDefaultLanguage(state, payload) {
    state.defaultLanguage = payload.defaultLanguage;
    if (!(localStorage.getItem('locale') !== null)) {
      state.currentLocale = state.defaultLanguage !== '' ? state.defaultLanguage : 'EN';
      localStorage.setItem('locale', state.currentLocale);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/i18n/mutations.js